/* eslint-disable no-nested-ternary */
import clsx from "clsx"
import React from "react"

import Button from "../components/Button"
import PageGrid from "../components/PageGrid"

interface TextProps {
  title: string
  eyebrow?: string
  eyebrowClass?: string
  leftDescription?: string | string[] | React.ReactNode
  wrapperClassLeft?: string
  hasButton?: boolean
  buttonCTA?: string
  buttonTo?: string
  fullLayout?: boolean
  bigText?: boolean
}

const SplitTextLeft: React.FC<TextProps> = ({
  title,
  eyebrow,
  eyebrowClass,
  leftDescription,
  wrapperClassLeft,
  hasButton = false,
  buttonCTA,
  buttonTo,
  fullLayout = true,
  bigText = false,
}) => (
  <PageGrid className={clsx(wrapperClassLeft)}>
    <div
      className={clsx(
        "p-4 col-span-full",
        fullLayout
          ? "md:col-span-3 lg:col-span-8 xl:col-span-7"
          : "md:col-span-2 lg:col-span-6",
      )}
    >
      {eyebrow && (
        <h5 className={clsx(eyebrowClass, "mb-4 heading3")}>{eyebrow}</h5>
      )}
      <h2 className="heading1 lg:headline4 md:headline5">{title}</h2>
      {leftDescription &&
        (Array.isArray(leftDescription) ? (
          leftDescription.map((description, index) => (
            <p
              key={description}
              className={clsx(
                bigText ? "mt-4" : index === 0 ? "mt-16" : "mt-4",
                "body3 lg:body2",
              )}
            >
              {description}
            </p>
          ))
        ) : (
          <p className={clsx(bigText ? "mt-4" : "mt-16", "body3 lg:body2")}>
            {leftDescription}
          </p>
        ))}
    </div>
    {hasButton && (
      <div className="p-4 col-span-full md:col-span-1 lg:col-span-4 xl:col-span-5">
        <p className="float-right">
          <Button to={buttonTo}>{buttonCTA}</Button>
        </p>
      </div>
    )}
  </PageGrid>
)

export default SplitTextLeft
